import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default class IconButton {
	constructor(props){
		let {faIcon, imgUrl, text, onClick, className, disabled} = props;
		this._callbackClick = onClick;
		if(faIcon&&imgUrl)throw new Error('Both faIcon and imgUrl were provided');
		this._text = text;
		this._handleClick=this._handleClick.bind(this);
		this.dispose=this.dispose.bind(this);
		this._element = document.createElement('button');
		if(className){
			if(Array.isArray(className))
				className.forEach(c=>
				this._element.classList.add(c));
			else
				this._element.classList.add(className);
		}
		this._element.classList.add('icon-button');
		this._element.disabled = disabled?true:false;
		this._innerElement = document.createElement('div');
		this._innerElement.classList.add('inner');
		this._innerElement.addEventListener('click', this._handleClick);
		this._iconElement = document.createElement('div');
		this._iconElement.classList.add('icon');
		this._textElement= document.createElement('div');
		this._textElement.classList.add('text');
		
		this._element.appendChild(this._innerElement);
		this._innerElement.appendChild(this._iconElement);
		this._innerElement.appendChild(this._textElement);
		
		if(!faIcon){
			this._imgElement = document.createElement('img');
			this._imgElement.src = imgUrl;
			this._iconElement.appendChild(this._imgElement);
		}
		else{
			const fontAwesomeIconFactory = React.createFactory(FontAwesomeIcon);
			ReactDOM.render(fontAwesomeIconFactory(
				{  	className:"icon",
					icon:faIcon
				}),
				this._iconElement);
		}
	}
	get element(){
		return this._element;
	}
	_handleClick(e){
		this._callbackClick(e);
	}
	dispose(){
		this._innerElement.removeEventListener('click', this._handleClick);
	}
}
